export default __webpack_public_path__ + "static/media/sun-fog-trees.2067ff7f.gif";